import { ServiceMode } from '@rbi-ctg/menu';
import { ILoyaltyInRestaurantOrderLineItem, InputMaybe, Scalars } from 'generated/graphql-gateway';
import { LoyaltyAppliedOffer } from 'state/loyalty/types';

export enum ShortCodeState {
  None = 'NONE',
  Pending = 'PENDING',
  Expired = 'EXPIRED',
  RequestError = 'REQUEST_ERROR',
  Claimed = 'CLAIMED',
  // Cart Offer Validation Error
  OfferValidationError = 'OFFER_VALIDATION_ERROR',
}

export interface IShortCodeData {
  shortCode?: string;
  expiry?: string;
}

export interface IUserShortCode {
  shortCode?: string;
  shortCodeState: ShortCodeState;
  shortCodeLoading: boolean;
  getNewShortCode: (params: IGetNewShortCodeParams) => void;
  setShortCodeClaimed: () => void;
  setShortCodeExpired: () => void;
  resetShortCode: () => void;
}

interface IRestaurantShortCodeParams {
  inRestaurantOrder:
    | ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>
    | ILoyaltyInRestaurantOrderLineItem;
  loyaltyId: Scalars['LoyaltyID'];
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
  serviceMode: ServiceMode | null;
  appliedOffers: LoyaltyAppliedOffer[];
}
interface IRewardTierShortCodeParams {
  rewardTierId: string;
  restaurantId: string;
  loyaltyId: string;
}

export type IGetNewShortCodeParams = IRewardTierShortCodeParams | IRestaurantShortCodeParams;
